<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'ConciliationDataContent',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        text: 'Nome',
        value: 'originName',
      },
      {
        text: 'CNPJ/CPF',
        value: 'originDocument',
        handle: vm.formatDocument,
      },
      {
        text: 'Banco',
        value: 'originBankName',
      },
      {
        text: 'Código do banco',
        value: 'originBankCode',
      },
      {
        text: 'Agência',
        value: 'originAgency',
      },
      {
        text: 'Conta bancária',
        value: 'originAccount',
      },
      {
        text: 'Valor',
        value: 'value',
        handle: vm.handleCurrency,
      },
      {
        text: 'Data da conciliação',
        value: 'createdAt',
        handle: vm.handleConciliationDate,
      },
    ],
  }),
  methods: {
    handleConciliationDate(key) {
      return this.handleDate(
        key,
        'DD/MM/YYYY - HH:MM:SS',
      );
    },
  },
};
</script>
